import { deserialiseToHTML } from '@api/HelperAPI';
import { logError, TAGS } from '@iwLogger/IwDataDogLogger';
import { fetchGetLoanDocumentsUnsigned } from '@iwoca/lapi-client/edge_de';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../../../../../iwQueryClient/useStateKey';

export function useGetUnsignedDocument(documentId: string) {
    const stateKey = useStateKey();

    const { data: html } = useQuery({
        queryKey: ['fetchGetLoanDocumentsUnsigned', stateKey, documentId],
        queryFn: async () => {
            try {
                const response = await fetchGetLoanDocumentsUnsigned({
                    stateKey,
                    documentId,
                    query: { file_format: 'html' }
                });
                const [htmlData] = await deserialiseToHTML(response);
                return htmlData.data;
            } catch (error) {
                logError(
                    `useGetUnsignedDocument: failed to fetch document ${documentId}`,
                    { tags: TAGS.DE_LENDING }
                );
                throw error;
            }
        },
        suspense: true
    });

    if (html === undefined) {
        const message = `useGetUnsignedDocument: document not found: ${documentId}`;
        logError(message, { tags: TAGS.DE_LENDING });
        throw new Error(message);
    }

    return html;
}
